<script lang="ts">
  import { isPresent, type Requires } from '@yp/common/identity.ts';
  import { makeCallback } from '@yp/web.app/context.ts';
  import { Session, type SessionType } from '@yp/web.firebase/context.ts';
  import type { Snippet } from 'svelte';
  import { page } from '$app/state';

  const signIn = makeCallback('signIn');

  interface Props {
    needSignIn?: Snippet<[typeof signIn]>;
    allowed?: string[];
    children?: Snippet;
  }
  const { needSignIn, allowed = [], children }: Props = $props();

  const isAllowed = $derived(allowed.some((prefix) => page.url.pathname.startsWith(prefix)));

  function checkSession(
    session: SessionType | undefined,
  ): session is Requires<SessionType, 'user'> {
    const result = isPresent(session?.user);
    console.log('checkSession', { result });
    return result;
  }
</script>

<!-- DNS: Replace loadable with svelte-store -->
{#await Session.load() then}
  {#if !isAllowed && !checkSession($Session)}
    {#if needSignIn}
      {@render needSignIn(signIn)}
    {:else}
      <div>To continue, sign in.</div>
    {/if}
  {:else}
    <!-- N.B. Since Me is dependent on $Session, we need to tell svelte to stop caching Me.load().
         There is probably a better idiom here that is less error prone.
      -->
    {#key $Session}
      <!-- {#await Me.load() then me}
        {#if checkVitals($Session.user, me.data())} -->
      {@render children?.()}
      <!-- {/if}
      {/await} -->
    {/key}
  {/if}
{/await}
